import React from "react";
import "../App.scss";
import "./ConnectionError.scss";
import Footer from "../Footer/Footer";
import warningsvg from "./../images/Icons/warning.svg";

function ConnectionError() {
  return (
    <div className="grid-container">
      <main className="tracker connection-error">
        <div className="error-image">
          <img src={warningsvg} alt="" />
        </div>
        <div className="error-text">
          <h1>
            Connection currently
            <br />
            unavailable.
          </h1>
          <h2>
            For train, tram, and bus information, visit ptv.vic.gov.au or call{" "}
            <span className="phone">1800 800 007</span>
          </h2>
        </div>
      </main>
      <Footer />
    </div>
  );
}
export default ConnectionError;
